exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disclaimer[data-v-499ce5b6],.privacy[data-v-499ce5b6]{white-space:pre-wrap}.red[data-v-499ce5b6]{color:red}.linker[data-v-499ce5b6]{color:#00f;text-decoration:underline}", ""]);

// exports
